export { ItemsTransfer } from './ItemsTransfer'



// WEBPACK FOOTER //
// ./src/components/ItemsTransfer/index.js